// extracted by mini-css-extract-plugin
export default {"learnedSection":"LearnedObject2_learnedSection__e912H","title":"LearnedObject2_title__z2em6","cardWrapper":"LearnedObject2_cardWrapper__0oNDo"};